import styled from "styled-components";

type ContainerProps = {
  bg?: string;
  h?: string;
  w?: string;
};

const Container = styled.div`
  display: flex;
  background-color: ${(props: ContainerProps) => (props.bg ? props.bg : "")};
  height: ${(props: ContainerProps) => (props.h ? props.h : "")};
  width: ${(props: ContainerProps) => (props.w ? props.w : "")};
`;

const RowContainer = styled(Container)`
  flex-direction: row;
`;

const ColContainer = styled(Container)`
  flex-direction: column;
  align-items: center;
`;

export { RowContainer, ColContainer };
